<template>
  <div class="monitoringBg">
    <el-row >
      <el-col :span="4" >
        <div class="tree-table back-ground" >

          <!-- <el-tree ref="myTree" class="filter-tree" :data="treeData"  :node-key="'id'"  default-expand-all @node-click="handleNodeClick"/> -->
          <el-tree ref="myTree" class="filter-tree" :data="treeData" :highlight-current="true"   :node-key="'id'"  default-expand-all @node-click="handleNodeClick">
            <template v-slot="{ node, data }">
                        <span class="custom-tree-node" :title="node.label">
                        {{ node.label }}
                        </span>
                    </template>
         
          </el-tree>
        </div>
      </el-col >
      <el-col :span="20">
        <el-row>
          <el-col :span="9" >
        

            <div class="info-box back-ground"   :style="`height: calc(${lastDivHeight}px); `">
                <!-- <p class="p-style-top">设备型号：<span>{{ deviceInfo.deviceType }}</span></p> -->
                <p class="p-style-top">设备名称：<span>{{ deviceInfo.deviceName }}</span></p>
                <p class="p-style">设备型号：<span>{{ deviceInfo.deviceType }}</span></p>
                <p class="p-style">设备位号：<span>{{ deviceInfo.deviceSn }}</span></p>
                <p class="p-style">设备功率(kw)：<span>{{ (deviceInfo.devicePower/1000).toFixed(2) }}</span></p>
                <p class="p-style">负载输出速度：<span>{{ deviceInfo.load_output_speed }}</span></p>
                <p class="p-style">电机类型：<span>{{ deviceInfo.is_fix_freq }}</span></p>
                <p class="p-style">生产厂商：<span>{{ deviceInfo.deviceFactory }}</span></p>
                <p class="p-style">设备位置：<span>{{ deviceInfo.devicePosition }}</span></p>
                <p class="p-style">转&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp速：<span>{{ deviceInfo.speed }}</span></p>
                <p class="p-style">算法延时：<span>{{ deviceInfo.alg_delay }}</span></p>
                <p class="p-style">停机输出：<span>{{ deviceInfo.enable_stopped_event_output }}</span></p>
            
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: flex-end; margin-top:5% ;">
                  <el-button style="height: 3vh;weight:20%;font-size: 1.5vh;" @click="loadingDeviceFn" type="primary" icon="Plus">编辑设备信息</el-button>
              </div>
            </div>
            <div class="show_3d" style="position: relative;">
            <div class="image1 back-ground"  :style="`height: calc(${image1DivHeight}px); `"  @click="upMax" >
            <span style="display:block;margin: 10px;">实时数据</span>
         
             <ul>
               <!-- <li style="text-align: left; padding-left: 10px">实时数据:</li> -->
               <li v-for="val in this.selectedSensorOptionsAll.items" :key="val.id" >
               
                <div v-if="val.type==1">
                  {{val.name}}：振动烈度{{val.intensity}}mm/s；
                   温度：{{val.temperature}}°C；
                   电池电量：{{(val.battery*100).toFixed(1)}}%
                  
                </div>
                <div v-if='val.type==2 ' style="text-align: left">
                  设备电流：
                  <span v-if="val.status != 4"> {{val.intensity}}A</span>;
                </div>
              </li>
               
             </ul>
            </div>
           </div>
       
         
          

          </el-col>
          <el-col :span="15">
            <el-row style="margin-top: 0px;" ref="topheight">
              
              <el-col :span="5">
                <p style="color: white;font-size: 20px;text-align: left;margin: 0px 0px 0px 10px;">设备健康趋势</p>
              </el-col>

              <el-col :span="4">
                <el-select v-model="selectedValue" style="margin-left: 10%;margin-top: -5px;">
                  <el-option
                    v-for="item in selectedOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>

              <el-col :span="4"> 
                <el-select  v-model="selectedSensor" style="margin-left: 10%;margin-top: -5px;">
                   
                   <el-option
                     v-for="item in selectedSensorOptions" :key="item.value" :label="item.label" :value="item.value" >
                   </el-option>
                   
                 </el-select>
                
              </el-col>

              <el-col :span="5">
                <el-button  @click="handleQuery"  style="width: 50px;margin-top: -5px;margin-left: 20px;"  type="primary" >查询</el-button>
              </el-col>
              <el-col :span="6">
                <div style="padding-top: 5px; display: flex;flex-direction: row;justify-content: flex-end; align-items: center;white-space: nowrap;">
                  <div class="color-box red" ></div>
                  <span>&nbsp&nbsp故障</span>
                  <div class="color-box gray"></div>
                  <span>&nbsp&nbsp停机</span>
                </div>
              </el-col>

           
            </el-row>

          
            <el-row style="margin-bottom:0px;margin-top: 5px;"  :style="`height: calc(${chatHeight*0.66}px); `"   >
              <el-col :span="24" >
                  <div  ref="lyechartmain" style="height: 100%;width: 100%;"></div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;margin-top: 10px;"  :style="`height: calc(${chatHeight*0.66}px); `">
              <el-col :span="24" >
                  <div  ref="AccIntensitychartmain" style="height: 100%;width: 100%;"></div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;margin-top: 10px;" :style="`height: calc(${chatHeight*0.66}px); `">
              <el-col :span="24" >
                  <div  ref="temperaturepic" style="height: 100%;width: 100%;"></div>
              </el-col>
            </el-row>
            <el-row  style="margin-bottom:0px;margin-top: 0px;height: 108px;" ref="tailHeight" >
              <el-col :span="24" class="back-ground" >

                    <p style="color: white;font-size: 20px;text-align: left;margin: 10px 0px 0px 20px;">设备健康报告</p>
                    
                    <div style="display: flex;  align-items: center;height: 100%;margin-top: -20px;">
                      <el-date-picker  style="width:250px;margin-left: 20px;"  v-model="searchDate"  type="month" ></el-date-picker>
                      <el-button  @click="handleQueryReport"  style="width: 15vh; margin-left: 20%;margin-right: 20%;"  type="primary" >预览&下载</el-button>

                      <el-upload
                        v-if="roleValue==0 "
                        action=""
                        :show-file-list="false"
                        ref="uploadPdfMonth"
                        :http-request="pdfMonthUploadRequest"
                        :on-success="pdfMonthUploadSuccess"
                        :before-upload="pdfMonthBeforeUpload">
                        <el-button v-if="roleValue==0 " type="primary"  style="width: 15vh;margin-right: 20%;">上传</el-button>
                     </el-upload>

                    </div>
                    

              </el-col>
            </el-row>

          </el-col>
        </el-row>

      </el-col>
    </el-row>
    <uploadingDevice ref="uploadingDeviceFlag" @addDeviceData="getData"></uploadingDevice>
  </div>
  <model/>
 
</template>


<script>
import {apiDevice,apiDeviceById,apiSensorlist,apiSensorDataHistory,apiUploadPdfMonth,apiPdfMonth} from '@/api/api'
import {dateFormats,getTableHeight} from "@/utils/util";
// import echarts from "@/components/analysis/echartsInstall";
import uploadingDevice from "./components/uploadingDevice";
import {url} from '@/api/url';
import * as echarts from 'echarts';
import {deepClone} from "@/utils/util";
import deviceTypeConfig from "@/config/index"
import {useMutitabsStore} from "@/store/mutitabs";
import {getStorage} from "@/utils/util";
import mitter from '@/utils/mitt';
import model3d from './components/model3d.vue';
import model from './components/model.vue'
import { log } from 'three/src/nodes/TSL.js';

export default {
    name: "deviceMonitoring",
    components:{
        uploadingDevice,
        // model3d,
        model,
      
    },
  
    data() {
        const today = new Date(); // 获取今天的日期  
        // const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate()); // 获取上个月的这一天
        const lastMonth = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000);
       
        return {
            roleValue: -1,
            selectedValue: 1,
         
         
            // 下拉框的选项
            selectedOptions: [
              { value: 0, label: '最近3天' },
              { value: 1, label: '最近1个月' },
              { value: 2, label: '最近3个月' },
              { value: 3, label: '最近半年' },
              { value: 4, label: '最近一年' },
            ],

            selectedSensor: null,
            selectedSensorType:null,
            selectedSensorOptions: [],
            selectedSensorOptionsAll:[],

            tableHeight:500,
            loadingPage:false,

            tableData:[],

            treeData: [
                    {
                    label: '内蒙古宜化化工有限公司',
                    children: [
                        {
                            label: deviceTypeConfig.DEVICE_TYPE_1,
                            children: []
                        },
                        {
                            label:deviceTypeConfig.DEVICE_TYPE_2,
                            children: []  
                        },
                        {
                            label:deviceTypeConfig.DEVICE_TYPE_3 ,
                            children: [] 
                        }
                        ,
                        {
                            label:deviceTypeConfig.DEVICE_TYPE_4,
                            children: [] 
                        }
                    ]
                    }       
                ],
            sensorval : [],
            deviceInfo:{
                  id:null,
                  deviceName : null,
                  deviceType : null,
                  deviceSn : null,
                  devicePower : null,
                  deviceFactory : null,
                  devicePosition : null,
                  load_output_speed:null,
                  is_fix_freq:null,
                  pic_url : "",
                  env_pic_url : "",
                  speed:null,
                  alg_delay:null,
                  enable_stopped_event_output:null

            },

            lastDivHeight:400,
            imageDivHeight:436,
            image1DivHeight:480,
            image2DivHeight:250,

            chatHeight: 50,

              treeState:{
                 hightLightFlag : false, 
                 hightLightDeviceName : "",
              },

              selectDeviceInfo : {},
              tableLineData:{},
  
              //route
              route_para :{
                deviceName : "name",
                flag : false ,
                parsePara : {
                   deviceId : 0,
                }
              },
              // defaultDevImg:'this.src="'+require('../../assets/bigscreen/devicePic.jpg')+'"',
              // defaultEnvImg:'this.src="'+require('../../assets/bigscreen/envPic.jpg')+'"', 

              
              trendsData_state : false,

                // 烈度曲线图
                myChart: null,
                lyechartmain: null,
                option: { 
                    backgroundColor: 'rgba(48, 56, 127, 0.8)',
                    grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '18%',   
				        bottom: '5%', 
				        containLabel: true 
				        },
                tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        axisLabel: {
                          show: true,
                          fontSize: 10,
                          margin: 10, 
                          color: '#ffffff'
                        },
                    },
                    yAxis: {
                        show: true,
                        name:"振动烈度 mm/s",
                        nameTextStyle: {  
                            color: '#FFFFFF',
                            padding: [0, 0, 0, 100],
                            fontSize: 15,
			              },
                        position: 'left',
                        type: 'value',
                        // axisLine: {  
                        //     show: true  
                        // },
                        axisLine: {
                            show: true,
                            // lineStyle: {
                            //     color: 'red',
                            //     width: 10,
                            //     type: 'solid'
                            // },
                            // onZero: true,
                            // symbol: 'arrow'
                        },
                        axisTick: {  
                            show: true,
                            // length:0 
                        },
                        axisLabel: { 
                            color: '#ffffff',
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                shadowBlur: 0,
                                shadowOffsetX:0,
                                shadowOffsetY:0,
                                opacity:0
                            }
                        },
                        splitLine: {
                            show:true, 
                            lineStyle: {
                                type: "dotted",
                                width: 1,
                                color: 'rgba(100, 100, 100, 0.8)', 
                                dashOffset: 10 ,
                            }
                        }
                    },
                    color: ['#268AFF'],
                    series: [
                    {  
                      // large: true, // 开启 large 模式
                      // largeThreshold: 10000, // 设置 large 模式的阈值，当数据量超过这个值时，自动
                        data:[],
                        type: 'line', // 曲线图类型
                        // smooth: false, 
                        // symbol: 'circle', // 将标记点指定为圆形
                        // showSymbol: true,
                        symbol: 'circle',
                        symbolSize: 0,
                        // itemStyle: {
                        //     borderWidth: 00,
                        //     borderColor: '#EE6666',
                        //     color: 'yellow'
                        // },

                        markPoint : {
                            clickable:false,
                            symbol:"circle",
                            symbolSize:10,
                            data : []
                        },
                    }
                    ]
                },
                
                // 加速度曲线图
                myAccIntensityChart: null,
                AccIntensitychartmain: null,
                AccIntensityOption: { 
                backgroundColor: 'rgba(48, 56, 127, 0.8)',
                grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '18%',   
				        bottom: '5%', 
				        containLabel: true 
				    },
            tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        axisLabel: {
                          show: true,
                          fontSize: 10,
                          margin: 10, 
                          color: '#ffffff'
                        },
                    },
                    yAxis: {
                        show: true,
                        name:"加速度烈度 m/s²",
                        nameTextStyle: {  
                            color: '#FFFFFF',
                            padding: [0, 0, 0, 110],
                            fontSize: 15,
			            },
                        position: 'left',
                        type: 'value',
                        axisLine: {
                            show: true,
                        },
                        axisTick: {  
                            show: true,
                        },
                        axisLabel: { 
                            color: '#ffffff',
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                shadowBlur: 0,
                                shadowOffsetX:0,
                                shadowOffsetY:0,
                                opacity:0
                            }
                        },
                        splitLine: {
                            show:true, 
                            lineStyle: {
                                type: "dotted",
                                width: 1,
                                color: 'rgba(100, 100, 100, 0.8)', 
                                dashOffset: 10 ,
                            }
                        }
                    },
                    color: ['#268AFF'],
                    series: [
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                    }
                    ]
                },
                // 温度曲线图
                temperaturepicChart:null,
                temperaturepic:null,
                  temperaturepicOption: {
                    backgroundColor: 'rgba(48, 56, 127, 0.8)',
                    grid: {
                      left: '2%',
                      right: '2%',
                      top: '18%',
                      bottom: '5%',
                      containLabel: true
                    },
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                      type: 'category',
                      data: [],
                      axisLabel: {
                        show: true,
                        fontSize: 10,
                        margin: 10,
                        color: '#ffffff'
                      },
                    },
                    yAxis: {
                      show: true,
                      name: "温度 ℃",
                      nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [0, 0, 0, 50],
                        fontSize: 15,
                      },
                      position: 'left',
                      type: 'value',
                      axisLine: {
                        show: true,
                      },
                      axisTick: {
                        show: true,
                      },
                      axisLabel: {
                        color: '#ffffff',
                      },
                      splitArea: {
                        show: true,
                        areaStyle: {
                          shadowBlur: 0,
                          shadowOffsetX: 0,
                          shadowOffsetY: 0,
                          opacity: 0
                        }
                      },
                      splitLine: {
                        show: true,
                        lineStyle: {
                          type: "dotted",
                          width: 1,
                          color: 'rgba(100, 100, 100, 0.8)',
                          dashOffset: 10,
                        }
                      }
                    },
                    color: ['#268AFF'],
                    series: [
                      {
                        data: [],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                         markPoint : {
                            clickable:false,
                            symbol:"circle",
                            symbolSize:10,
                            data : []
                        },
                      }
                    ]

                  },
               
            searchDate:"",

            charDataState:false,
            stop_putout_flag:true,
        };              
    },
    methods:{
      getData(val) {

        this.loadingPage = false

        if(this.treeState.hightLightFlag){
       
            let fnParm = {
              id : val.id,
            }
            apiDeviceById(fnParm).then(res=>{
             
              if(res.code ==200) {
                   this.deviceInfo.id = res.data.id
                  this.deviceInfo.deviceName = res.data.name
                  this.deviceInfo.deviceType = res.data.model
                  this.deviceInfo.deviceSn = res.data.psn
                  this.deviceInfo.devicePower = res.data.power
                  this.deviceInfo.deviceFactory = res.data.manufactor
                  this.deviceInfo.devicePosition= res.data.location
                  this.deviceInfo.speed = res.data.speed
                  this.deviceInfo.alg_delay = res.data.alg_delay
                  this.deviceInfo.load_output_speed = res.data.load_output_speed
                  if(res.data.is_fix_freq){
                    this.deviceInfo.is_fix_freq = "定频"
                  }else this.deviceInfo.is_fix_freq = "变频"
                  if(res.data.enable_stopped_event_output){
                    this.deviceInfo.enable_stopped_event_output = "是"
                    this.stop_putout_flag = true;
                  }
                  else{
                    this.deviceInfo.enable_stopped_event_output = "否"
                    this.stop_putout_flag = false;
                  }
              }
            }) .catch(res => {  
              this.$message.warning(`刷新单个设备信息失败 : ${res.msg}`)
            }); 
        }
      },
      // 3D展示图
      upMax(){
     
        
        mitter.emit("showflag3d",[true,this.selectedSensorOptionsAll.items])
      },

      dataChange(item){
          this.tableData.length = 0
          for(let i = 0;i<item.length;i++){
              this.tableData[i] = item[i]

              switch(item[i].device_type){
                  case 1:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_1 ;break;
                  case 2:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_2 ;break;
                  case 3:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_3 ;break;
                  case 4:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_4 ;break;
                  default: this.tableData[i].transform_device_type="未定义" ;break;
              }
              
              if(item[i].fault_id == null || item[i].fault_id == "")
                  this.tableData[i].fault_id = '-'
              else
                  this.tableData[i].fault_id    = item[i].fault_id

              if(item[i].time == null)
                  this.tableData[i].time = '-'
              else
                  this.tableData[i].time = item[i].time
              switch(item[i].level){
                  case 0:  this.tableData[i].transform_level="健康" ;break;
                  case 1:  this.tableData[i].transform_level="预警" ;break;
                  case 2:  this.tableData[i].transform_level="轻微" ;break;
                  case 3:  this.tableData[i].transform_level="普通" ;break;
                  case 4:  this.tableData[i].transform_level="高危" ;break;
                  default: this.tableData[i].transform_level="未定义" ;break;
              }

              if(item[i].processed)
                  this.tableData[i].transform_state="已处理" ;
              else
                  this.tableData[i].transform_state="未处理" ;

              if(item[i].processed){
                  switch(item[i].processed_type){
                      case 0:   this.tableData[i].transform_type="空" ;break;
                      case 1: this.tableData[i].transform_type="停机" ;break;
                      case 99: this.tableData[i].transform_type="其他故障" ;break;
                      case 100: this.tableData[i].transform_type="模拟故障" ;break;
                      case 101: this.tableData[i].transform_type="转子不对中" ;break;
                      case 102: this.tableData[i].transform_type="转子不平衡" ;break;
                      case 103: this.tableData[i].transform_type="轴弯曲" ;break;
                      case 104: this.tableData[i].transform_type="轴裂纹" ;break;
                      case 105: this.tableData[i].transform_type="轴承松动" ;break;
                      case 106: this.tableData[i].transform_type="滚动轴承故障" ;break;
                      case 107: this.tableData[i].transform_type="滑动轴承故障" ;break;
                      case 201: this.tableData[i].transform_type="UPS温度过高" ;break;
                      case 202: this.tableData[i].transform_type="UPS电源局部放电" ;break;
                      case 203: this.tableData[i].transform_type="UPS电源机械性故障" ;break;                            
                      case 301: this.tableData[i].transform_type="空调压缩机故障" ;break;
                      case 401: this.tableData[i].transform_type="变压器局部放电" ;break;
                      case 402: this.tableData[i].transform_type="变压器绕组形变" ;break;
                      case 403: this.tableData[i].transform_type="变压器部件松动" ;break;
                      case 404: this.tableData[i].transform_type="变压器直流偏磁" ;break;
                      default:  this.tableData[i].transform_type="未定义" ;break;
                  }
              }else{
                  switch(item[i].type){
                      case 0:   this.tableData[i].transform_type="空" ;break;
                      case 1: this.tableData[i].transform_type="停机" ;break;
                      case 99: this.tableData[i].transform_type="其他故障" ;break;
                      case 100: this.tableData[i].transform_type="模拟故障" ;break;
                      case 101: this.tableData[i].transform_type="转子不对中" ;break;
                      case 102: this.tableData[i].transform_type="转子不平衡" ;break;
                      case 103: this.tableData[i].transform_type="轴弯曲" ;break;
                      case 104: this.tableData[i].transform_type="轴裂纹" ;break;
                      case 105: this.tableData[i].transform_type="轴承松动" ;break;
                      case 106: this.tableData[i].transform_type="滚动轴承故障" ;break;
                      case 107: this.tableData[i].transform_type="滑动轴承故障" ;break;
                      case 201: this.tableData[i].transform_type="UPS温度过高" ;break;
                      case 202: this.tableData[i].transform_type="UPS电源局部放电" ;break;
                      case 203: this.tableData[i].transform_type="UPS电源机械性故障" ;break;                            
                      case 301: this.tableData[i].transform_type="空调压缩机故障" ;break;
                      case 401: this.tableData[i].transform_type="变压器局部放电" ;break;
                      case 402: this.tableData[i].transform_type="变压器绕组形变" ;break;
                      case 403: this.tableData[i].transform_type="变压器部件松动" ;break;
                      case 404: this.tableData[i].transform_type="变压器直流偏磁" ;break;
                      default:  this.tableData[i].transform_type="未定义" ;break;
                  }
              }
            }
      },

      async handleNodeClick(node) {
       
        this.deviceInfo.id = ""
        this.deviceInfo.deviceName = ""
        this.deviceInfo.deviceType =    ""
        this.deviceInfo.deviceSn =      ""
        this.deviceInfo.devicePower =   ""
        this.deviceInfo.deviceFactory = ""
        this.deviceInfo.devicePosition= "" 
        this.deviceInfo.pic_url= ""
        this.deviceInfo.env_pic_url= ""
        this.deviceInfo.speed = ""
        this.deviceInfo.alg_delay = ""
        this.deviceInfo.is_fix_freq=""
        this.deviceInfo.load_output_speed=""
        this.deviceInfo.enable_stopped_event_output = ""
        
        this.tableData.length = 0

        this.treeState.hightLightFlag = false 
        this.loadingPage = true

       
      

        if(!('children' in node)) {
          

            this.treeState.hightLightFlag = true
            this.treeState.hightLightDeviceName = node.label
            this.trendsData_state = false;
            let fnParm = {
              id : node.id,
            }
         
            
            apiDeviceById(fnParm).then(res=>{
             
           
              
              if(res.code ==200) {
                  this.deviceInfo.id = res.data.id
                  this.deviceInfo.deviceName =    res.data.name
                  this.deviceInfo.deviceType =    res.data.model
                  this.deviceInfo.deviceSn =      res.data.psn
                  this.deviceInfo.devicePower =   res.data.power
                  this.deviceInfo.deviceFactory = res.data.manufactor
                  this.deviceInfo.devicePosition= res.data.location
                  this.deviceInfo.speed = res.data.speed
                  this.deviceInfo.alg_delay = res.data.alg_delay
                  this.deviceInfo.load_output_speed = res.data.load_output_speed
                  if(res.data.is_fix_freq){
                    this.deviceInfo.is_fix_freq = "定频"
                  }else this.deviceInfo.is_fix_freq = "变频"
                  if(res.data.enable_stopped_event_output){
                    this.deviceInfo.enable_stopped_event_output = "是"
                    this.stop_putout_flag = true;
                  }
                  else{
                    this.deviceInfo.enable_stopped_event_output = "否"
                    this.stop_putout_flag = false;
                  }

                  

                  if(res.data.pic_url == "" || res.data.pic_url == null){
                    this.deviceInfo.pic_url = ""
                  }
                  else{
                    var pic_split = res.data.pic_url.split("//")[1].split("/").slice(1).join("/")
                    this.deviceInfo.pic_url = url + pic_split
                  }

                  if(res.data.env_pic_url == "" || res.data.env_pic_url == null){
                    this.deviceInfo.env_pic_url = ""
                  }
                  else{
                    var pic_split = res.data.env_pic_url.split("//")[1].split("/").slice(1).join("/")
                    this.deviceInfo.env_pic_url = url + pic_split
                  }

                  this.selectDeviceInfo = res.data
                 
              }else{
                  this.deviceInfo.deviceName = ""
                  this.deviceInfo.deviceType =    ""
                  this.deviceInfo.deviceSn =      ""
                  this.deviceInfo.devicePower =   ""
                  this.deviceInfo.deviceFactory = ""
                  this.deviceInfo.devicePosition= "" 
                  this.deviceInfo.pic_url= ""
                  this.deviceInfo.env_pic_url= ""
                  this.deviceInfo.speed = ""
                  this.deviceInfo.alg_delay = ""
                  this.deviceInfo.enable_stopped_event_output = ""
                  this.selectDeviceInfo = null
                  this.loadingPage = false
                  this.$message.warning(`获取单个设备信息失败`)
              }
            }) .catch(res => {  
                this.deviceInfo.deviceName = ""
                this.deviceInfo.deviceType =    ""
                this.deviceInfo.deviceSn =      ""
                this.deviceInfo.devicePower =   ""
                this.deviceInfo.deviceFactory = ""
                this.deviceInfo.devicePosition= "" 
                this.deviceInfo.pic_url= ""
                this.deviceInfo.env_pic_url= ""

                this.deviceInfo.speed = ""
                this.deviceInfo.alg_delay = ""
                this.deviceInfo.enable_stopped_event_output = ""

                this.selectDeviceInfo = null          
                this.loadingPage = false    
                this.$message.warning(`获取单个设备信息失败 : ${res.msg}`)
            }); 
          } else {
            this.loadingPage = false
          }

          this.charDataState = false;
          await this.getSensor()
          this.drawChar()
          
      },

      loadingDeviceFn(){
          if(this.treeState.hightLightFlag){
            this.$refs.uploadingDeviceFlag.addDeviceFn(this.selectDeviceInfo,`上传设备信息/${this.treeState.hightLightDeviceName}`)
          }else{
            this.$message.warning("请先选择设备")
          }
      },


      listenResize() {
        this.$nextTick(() => {
          this.getTheHeight()
          this.getTheChartHeight()
          if(this.chatHeight > 100)
            this.drawChar()
        })
      },

      getTheHeight(){
          var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
          

          // let topDiv = this.$refs.topDivHeight.offsetHeight
          let topDiv = 30

          let height = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)  - 150 - 2*bg_padding - topDiv
          this.image1DivHeight = height /2 + topDiv; 
        
          this.lastDivHeight = height/2 +  15
      },

      getTheChartHeight(){
          var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
          let height = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)  - 150 - 2*bg_padding
   
          let top = this.$refs.topheight.$el.offsetHeight
          let tail = this.$refs.tailHeight.$el.offsetHeight
          this.chatHeight = (height - top -tail) / 2

      },


      handleEdit(row,flag) {
          if(flag == "viewDetails"){
            let name = "故障告警/告警详情：" + row.device_name
            this.tableLineData = row
            this.$refs.faultInfoFlag.faultInfoFn(row,name)
          }
      },

   
      async getTreeData() {   
        try{
         const res =  await apiDevice()
          if (res.data.code == 200) {

            this.treeData = [{
              label: '内蒙古宜化化工有限公司',
              //children:[]
              children: [
                { label: deviceTypeConfig.DEVICE_TYPE_1, children: [] },
                { label: deviceTypeConfig.DEVICE_TYPE_2, children: [] },
                { label: deviceTypeConfig.DEVICE_TYPE_3, children: [] },
                { label: deviceTypeConfig.DEVICE_TYPE_4, children: [] },
                { label: deviceTypeConfig.DEVICE_TYPE_5, children: [] },
                { label: deviceTypeConfig.DEVICE_TYPE_6, children: [] }
              ]
            }]

            let factory = [
              deviceTypeConfig.DEVICE_TYPE_1,
              deviceTypeConfig.DEVICE_TYPE_2,
              deviceTypeConfig.DEVICE_TYPE_3,
              deviceTypeConfig.DEVICE_TYPE_4,
              deviceTypeConfig.DEVICE_TYPE_5,
              deviceTypeConfig.DEVICE_TYPE_6
            ]
            for (let i = 0; i < res.data.data.total; i++) {
              let index = factory.indexOf(res.data.data.items[i].branch_factory)
              if (index == -1)
                continue;
              let node = this.treeData[0].children[index]
              let find_flag = 0
              let j = 0;


              for (j = 0; j < node.children.length; j++) {
                if (node.children[j].label == res.data.data.items[i].workshop_section) {
                  find_flag = 1
                  break;
                }
              }


              if (find_flag == 1) {
                this.treeData[0].children[index].children[j].children.push({
                  label: res.data.data.items[i].name,
                  id: res.data.data.items[i].id
                });
              } else {
                this.treeData[0].children[index].children.push({
                  label: res.data.data.items[i].workshop_section,
                  children: []
                });
                this.treeData[0].children[index].children[this.treeData[0].children[index].children.length - 1].children.push({
                  label: res.data.data.items[i].name,
                  id: res.data.data.items[i].id
                });
              }

            }
          }
      }  catch (error) {
        // 错误处理...
           console.error('获取设备列表失败', error);
        }
      
     },

   
     

      
      //chart ---------------------
      async getTrendsData() {
        
        for(let i = 0;i<this.selectedSensorOptions.length;i++){
          if(this.selectedSensor == this.selectedSensorOptions[i].value){
            this.selectedSensorType = this.selectedSensorOptions[i].sensortype
          }
        }
        if(this.treeState.hightLightFlag){
         
            await this.getIntensityChartData()


            if(this.myChart != null){
        
              this.myChart.setOption(this.option);
            }else{
          
              this.lyechartmain = this.$refs.lyechartmain;
              this.myChart = echarts.init(this.lyechartmain);
              this.myChart.setOption(this.option);
            }

            if(this.myAccIntensityChart != null){
              this.myAccIntensityChart.setOption(this.AccIntensityOption);
            }else{
              this.AccIntensitychartmain = this.$refs.AccIntensitychartmain;
              this.myAccIntensityChart = echarts.init(this.AccIntensitychartmain);
              this.myAccIntensityChart.setOption(this.AccIntensityOption);
            }
            if(this.temperaturepicChart != null){

              this.temperaturepicChart.setOption(this.temperaturepicOption);
            }else{

              this.temperaturepic = this.$refs.temperaturepic;
              this.temperaturepicChart  = echarts.init(this.temperaturepic);
              this.temperaturepicChart.setOption(this.temperaturepicOption);
            }
           


        } else {

            if(this.myChart != null){
                this.option.series[0].data = []
                this.option.xAxis.data = []
                this.myChart.setOption(this.option);
            }else{
                this.option.series[0].data = []
                this.option.xAxis.data = []
                this.lyechartmain = this.$refs.lyechartmain;
                this.myChart = echarts.init(this.lyechartmain);
                this.myChart.setOption(this.option);   

            }

            if(this.myAccIntensityChart != null){
              temperaturepicChart = []
                this.AccIntensityOption.xAxis.data = []
                this.myAccIntensityChart.setOption(this.AccIntensityOption);
            }else{
                this.AccIntensityOption.series[0].data = []
                this.AccIntensityOption.xAxis.data = []
                this.AccIntensitychartmain = this.$refs.AccIntensitychartmain;
                this.myAccIntensityChart = echarts.init(this.AccIntensitychartmain);
                this.myAccIntensityChart.setOption(this.AccIntensityOption);
            }
            if(this.temperaturepicChart != null){
                this.temperaturepicOption.series[0].data = []
                this.temperaturepicOption.xAxis.data = []
                this.temperaturepicChart.setOption(this.temperaturepicOption);

            }else{
                this.temperaturepicOption.series[0].data = []
                this.temperaturepicOption.xAxis.data = []
                this.temperaturepic = this.$refs.temperaturepic;
                this.temperaturepicChart = echarts.init(this.temperaturepic);
                this.temperaturepicChart.setOption(this.temperaturepicOption);
            }
          
            }
        },
      
                
  
      drawChar(){
          if(this.myChart != null){
              this.myChart.dispose()
              this.myChart = null
          }

          if(this.myAccIntensityChart != null){
              this.myAccIntensityChart.dispose()
              this.myAccIntensityChart = null
          }
          if(this.temperaturepicChart != null){
              this.temperaturepicChart.dispose()
              this.temperaturepicChart = null
          }
         
            this.$nextTick(() => {
                this.getTrendsData();
               
            });
      },
      //页面加载完毕后获取到自动点击第一个节点
      route_jump_handle(){
        
         // 确保树形数据已加载
       if (this.treeData.length > 0) {
        // 获取第一个节点
        const firstNode = this.treeData[0];
        // 获取第一个节点的第一个子节点
        const secondLevelNode = firstNode.children[0];
        // 获取第二个节点的第一个子节点
        const thirdLevelNode = secondLevelNode.children[0];
        // 获取第三个节点的第四个子节点
        const fourthLevelNode = thirdLevelNode.children[0];

        if (fourthLevelNode) {
          // 触发第四个子节点的点击事件
          this.handleNodeClick(fourthLevelNode, { data: fourthLevelNode });
        }
      }
      
      },
      
      async sleep(ms) {  
        return new Promise(resolve => setTimeout(resolve, ms));  
      },

      async getSensor(){
        this.selectedSensor = null
        
        this.selectedSensorOptions = []
        if(this.treeState.hightLightFlag){
          let parm = {
          device_name_exact: this.treeState.hightLightDeviceName,  
          }

          try{
            let parm = {
              device_name_exact: this.treeState.hightLightDeviceName,  
            }
            const res = await apiSensorlist(parm);
          
            
            if(res.data.code ==200) {
                let data =  res.data.data
                this.selectedSensorOptionsAll = data
               
                for(let i = 0;i<data.total;i++){  
                  if(this.selectedSensorOptionsAll.items[i].status == 3){
                    this.selectedSensorOptionsAll.items[i].intensity =0
                  }
               
    
                  this.selectedSensorOptions.push( {value:data.items[i].sn, label:data.items[i].name, sensortype:data.items[i].type} )
                 
                }
                
                this.selectedSensor = data.items[0].sn
                
                
            } else {
              this.$message.warning(`获取设备sensor信息失败`)
            }
          }catch(error){
            this.$message.error(`获取设备sensor信息失败`)
          }  
        }
      
      },

      calcStep(total){
        let step = 0
        if(total > 500){
            step = Math.floor(total / 500) - 1
        }
        return step;
      },
      //  获取波形数据
      async getIntensityChartData(){
        if(this.selectedSensor == null || this.selectedSensor == ""){
          this.option.series[0].data = []
          this.option.xAxis.data = []
          this.AccIntensityOption.series[0].data = []
          this.AccIntensityOption.xAxis.data = []
          return;
        }


        if(this.charDataState){ //拉取一次
          return;
        }

        let timeMap = [3,30,90,180,360]
        let data = timeMap[this.selectedValue]
        const now = new Date();
        const year = now.getFullYear();
        let month = now.getMonth() + 1; 
        let day = now.getDate();
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
        const timeNow = `${year}-${month}-${day}`;
        const before = new Date(now.getTime() - data * 24 * 60 * 60 * 1000);
        let  beforeMonth = before.getMonth() + 1;
        let beforeDay = before.getDate();
        beforeMonth = beforeMonth < 10 ? '0' + beforeMonth : beforeMonth;
        beforeDay = beforeDay < 10 ? '0' + beforeDay : beforeDay;
        const timeBefore = `${before.getFullYear()}-${beforeMonth}-${beforeDay}`;
        

        this.option.series[0].data = []
        this.option.xAxis.data = []
        this.AccIntensityOption.series[0].data = []
        this.AccIntensityOption.xAxis.data = []
        this.option.series[0].markPoint.data = []

        try{
           
            var para = {
                sn : this.selectedSensor,
                time_after: timeBefore,
                time_before: timeNow,
                count: 500
            }
            const res = await apiSensorDataHistory(para)
            if(res.data.code == 200){
                this.charDataState = true //拉取一次

                var Xarray= []
                var Yarray= []
                var AccIntensityXarray= []
                var AccIntensityYarray= []
                var temperatureXarray =[]
                var temperatureYarray = []

                var makePoint = []
                let makePointTemp = []
            
                
                
                console.log("选择设备的型号", this.selectedSensorType)
                
            
                for(let i = 0; i<res.data.data.items.length; i++){
                    var yValue = 0.0
                   
                    var part = res.data.data.items[i].time.split(":");
                    var part1 = part[1].split(":");
                    var xValue = part[0]+":"+part1[0]
                    if(res.data.data.items[i].alarm_type == 1){
                        
                      makePoint.push({xAxis: xValue, yAxis:res.data.data.items[i].intensity,itemStyle: {color: 'gray'}})  
                      Yarray[i] =res.data.data.items[i].intensity
                      // if(res.data.data.items[i].temperature ==0 && i>0 ){
                      //    temperatureYarray[i] = res.data.data.items[i-1].temperature
                      // }else{
                      //     temperatureYarray[i] = res.data.data.items[i].temperature
                      // }
                     
                      }
                    if(res.data.data.items[i].alarm_type <1001 && res.data.data.items[i].alarm_type > 1 ){
                    
                      makePoint.push({xAxis: xValue, yAxis:res.data.data.items[i].intensity,itemStyle: {color: 'red'}}) 
                      
                      Yarray[i] =res.data.data.items[i].intensity
                    
                      // temperatureYarray[i] = res.data.data.items[i].temperature
                      
                    }
                    if(res.data.data.items[i].alarm_type == 1001){
                        makePointTemp.push({xAxis: xValue, yAxis:res.data.data.items[i].temperature,itemStyle: {color: 'red'}}) 
                        temperatureYarray[i] = res.data.data.items[i].temperature
                        if(i>0){
                            Yarray[i] =res.data.data.items[i-1].intensity
                        }
                      
                    }
                     
                    if(res.data.data.items[i].alarm_type <1 ){
                        yValue  = res.data.data.items[i].intensity
                        Yarray.push(yValue)
                     
                        // if(res.data.data.items[i].temperature ==0 && i>0){
                        //   temperatureYarray[i] = res.data.data.items[i-1].temperature
                        // }
                        
                    }
                
                    Xarray.push(xValue)
                   
                    AccIntensityXarray.push(xValue)
                    AccIntensityYarray.push(res.data.data.items[i].aspeed_intensity)
                    temperatureYarray.push(res.data.data.items[i].temperature)
                    temperatureXarray.push(xValue)
            
                } 

                // 振动
                this.option.xAxis.data = Xarray
                this.option.series[0].data = Yarray
                this.option.yAxis.name = this.selectedSensorType == 1 ? '振动烈度 mm/s' :"电流 A             "
        
                // 加速度
                this.AccIntensityOption.xAxis.data = AccIntensityXarray
                this.AccIntensityOption.series[0].data = AccIntensityYarray
                
                // 温度
                this.temperaturepicOption.xAxis.data = temperatureXarray
                this.temperaturepicOption.series[0].data = temperatureYarray
               
                this.option.series[0].markPoint.data = makePoint
                this.temperaturepicOption.series[0].markPoint.data = makePointTemp

               
                
            }
        } catch(error){
            console.log(error)
        }           
      },


      handleQuery(){
   
    
 
      
        if(this.selectedSensor != null){
          this.charDataState = false
           this.drawChar()
        }
      },


      handleQueryReport(){
        if(!this.treeState.hightLightFlag){
          this.$message.warning(`请先选择设备`)
          return
        }

        if(this.searchDate == null || this.searchDate == ""){
          this.$message.warning(`请选择查询时间`)
          return
        }

        const date = new Date(this.searchDate);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
        const time = `${year}${month}`;
        let parm = {
          device_name_exact : this.treeState.hightLightDeviceName,
          month : time
        }
        apiPdfMonth(parm).then(res=>{
         
            if(res.data.code == 10006){
              this.$message.warning(`报告资源不存在！`)
            }else if(res.data.code ==200) {
             
              if(res.data.data.url != null || res.data.data.url != ""){
                  let pdf_url = ""
                  var pic_split = res.data.data.url.split("//")[1].split("/").slice(1).join("/")
                  pdf_url = url + pic_split
                  window.open(pdf_url, '_blank');
              }else{
                this.$message.warning(`报告资源不存在！`)
              }
            } else {
              this.$message.warning("报告资源获取失败")
            }
        }) .catch(res => {  
            this.$message.warning(`报告资源获取失败 : ${res.msg}`)
        });

      },

      pdfMonthUploadSuccess() {
          this.$refs.uploadPdfMonth.clearFiles()
      },

      async pdfMonthUploadRequest(param) {
        if(!this.treeState.hightLightFlag){
          this.$message.warning(`PDF文档上传失败：未选择设备！`)
          return
        }

        if(this.searchDate == null || this.searchDate == ""){
          this.$message.warning(`PDF文档上传失败：未选择时间！`)
          return
        }

        const date = new Date(this.searchDate);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
        const time = `${year}${month}`;

          var vm = this
          let params = {
              param : param,
              device_name : this.treeState.hightLightDeviceName,
              month : time
          }
          try {
              let obj = await apiUploadPdfMonth(params);
              if(obj.code == 200) {
                  this.$message.success("PDF文档上传成功！")
              }else{
                  this.$message.warning("PDF文档上传失败！")
              }
          } catch (error) {
              console.error(error);
              this.$message.warning(`PDF文档上传失败！`)
          }
      },

      checkPdf(file) {
          const isPDF = file.type === 'application/pdf';
          const isLt10M = file.size / 1024 / 1024 < 10
          if (!isPDF) {
              this.$message.error('文件只能是 PDF 格式!');
              return false;
          }
          if (!isLt10M) {
              this.$message.error('文件大小不能超过 10MB!');
              return false;
          }
          return isPDF;
      },

      pdfMonthBeforeUpload(file){
          return this.checkPdf(file)
      },      
      
  
    },


    created() {
        if(this.$route.query.name){
          this.route_para.deviceName = this.$route.query.name 
          this.route_para.flag = true
        } else {
          this.route_para.flag = false
        } 
    },

    async mounted() {
      this.roleValue = getStorage('role')

      const today = new Date();
      this.searchDate = today.toISOString().split('T')[0].split('-').slice(0, 2).join('-');
      

     await this.getTreeData()
      
      
      this.getTheHeight()
      this.getTheChartHeight()
      window.addEventListener('resize', this.listenResize);

      await this.getSensor()
      
      this.$nextTick(() => {
          
        
          this.drawChar()  
          this.route_jump_handle()
          
          
       
          
      })

    },

    unmounted() {
        window.removeEventListener("resize", this.listenResize);
    },

}
</script>


<style lang="scss" scoped>

.back-ground{
  background: var(--l-searchtoolbar-bg); 
  box-shadow: var(--el-box-shadow-light);
  border: 1px solid var(--el-border-color-lighter);
}

.tree-table {
  height: calc(100vh - 130px - 2 * var(--my-css-var-bg-padding)); 
  margin-right: 10px; 
  overflow: auto;
  .el-tree {
            overflow-x: auto; /* 显示横向滚动条 */
           
            }
        .custom-tree-node{
            width: 100%;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 禁止自动换行 */
            text-overflow: ellipsis; /* 使溢出部分以省略号显示 */
            display: block; /* 确保样式生效 */ 
        }

}

.filter-tree{
  ::v-deep(.el-tree-node__content){
          height: 25px;
          font-size: 15px;
       
  }
}

::v-deep .el-tree-node.is-current > .el-tree-node__content {  
  background-color: #272727;   
}

.image1 {
  // height: 250px;
  background: url("@/assets/3dpic.png") no-repeat;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  font-size: 14px;
  margin: 10px 10px 10px 10px;
  ul{
     list-style: none;
     margin-left: 6%;
     margin-top:10px ;
     li{
      text-align: left;
      padding-top:6px;
     }
  }
}
.image1:hover::after{
   content: '点击查看3D图';
  // content:"\70B9\51FB\67E5\770B\33\44\56FE";
 
  position: absolute;
  left: 50%;
  bottom: 60%;
  transform: translateX(-50%);
  background-color: #4f6170;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 1;
  margin-bottom: 5px; /* 控制提示文字和元素之间的距离 */
}
.image2 {
  // height: 250px;
  margin: 0px 10px 10px 10px;
}

.info-box p {
  // margin: 20px 0px 0px 60px


}

.info-box {
  margin: 0px 10px 0px 10px;
  padding-bottom: 0px;
  padding-right: 10px;
}

.status-table {
  height: 220px;
  margin: 10px 0px 10px 10px;
}

.rt_trends {
    flex: 1;
    margin: 10px 0px 0px 10px;
    background-color: transparent;
  }
  

  .monitoringBg{
      background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      padding: var(--my-css-var-bg-padding);
  }

  .p-style {  
  color: white; /* 文本颜色 */  
  font-size: 1.5vh; /* 字体大小 */  
  line-height: 2.5vh; /* 行高 */  
  text-align: left; 
  margin: 0px 0px 0px 30px
}

  .p-style-top {  
    color: white; /* 文本颜色 */  
    font-size: 1.5vh; /* 字体大小 */  
    line-height: 2.5vh; /* 行高 */  
    text-align: left; 
    margin: 10px 0px 0px 30px
  }



  .color-box {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 10px;
}

.red {
  background-color: red;
}

.gray {
  background-color: gray;
}

</style>



